import { Size, TimerPinComponent, Vector } from '../../models';
import { newBox, newSize } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';
import { initialPinComponentPosition } from './pin-component';

export type TimerPinComponentProps = {
  id?: string;
  position?: Vector;
  size?: Size;
  rotation?: number;
  order?: string;
  settings?: Partial<TimerPinComponent['settings']>;
};

// Small enough to fit outside the content area of interactive pins.
export const minimumTimerComponentSize = newSize(192, 108);

export const initialTimerComponentSize = newSize(256, 144);

export function newTimerPinComponent({
  id = randomId(),
  position = initialPinComponentPosition,
  size = initialTimerComponentSize,
  rotation,
  order = defaultOrder,
  settings = {
    seconds: 60,
  },
}: TimerPinComponentProps): TimerPinComponent {
  if (size.width < minimumTimerComponentSize.width || size.height < minimumTimerComponentSize.height) {
    throw new Error(
      `Timer component size ${sizeToString(size)} is too small; ` +
        `need at least ${sizeToString(minimumTimerComponentSize)}`
    );
  }
  return {
    type: 'TIMER',
    id,
    settings,
    layout: newBox(position, size, rotation, true),
    order,
  };
}

function sizeToString(size: Size): string {
  return `(${size.width}, ${size.height})`;
}
